import { render, staticRenderFns } from "./RiverInfo.vue?vue&type=template&id=19b592b4&scoped=true"
import script from "./RiverInfo.vue?vue&type=script&lang=js"
export * from "./RiverInfo.vue?vue&type=script&lang=js"
import style0 from "./RiverInfo.vue?vue&type=style&index=0&id=19b592b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b592b4",
  null
  
)

export default component.exports